<style lang="less">
@import "./Main.less";
</style>
<template>
  <div class="main">
    <div
      class="head"
      :style="{backgroundImage: 'url('+require('../assets/images/bg-head.png')+')'}"
    >
      <div class="left">
        <div class="pic" v-if="type !== '2'">
          <img src="../assets/images/logo.png" />
        </div>
        <p v-if="type !== '2'">上海市绿色建筑协会专家系统</p>
        <p v-if="type === '2'">上海市绿色建筑专家系统</p>
      </div>
      <div class="right">
        <!-- <div class="applybtn">
          <Button type="text" @click="applyProcess">专家申请流程</Button>
        </div> -->
        <div class="message">
          <Poptip v-model="visible" placement="bottom-end" padding="5px">
            <Badge :count="messageList.length == 0 ? '' : messageList.length">
              <a href="#" class="box"></a>
            </Badge>
            <div slot="title">
              <i>
                消息列表(
                <span>{{this.messageList.length}}</span>)
              </i>
            </div>
            <div slot="content" class="list">
              <ul>
                <li v-for="(message, index) in messageList" :key="index">
                  <!-- <span>{{message.addtime}}</span> -->
                  <h3>{{message.message_title}}：</h3>
                  <p>{{message.message_content}}</p>
                  <div @click="readMessage(message.rel_id,1)">
                    <Icon type="ios-close-empty"></Icon>
                  </div>
                </li>
              </ul>
            </div>
          </Poptip>
        </div>

        <div class="head-pic">
          <div class="pic">
            <img :src="baseUrl + peopleImage" v-if="existPeopleImage" style="border-radius: 50%"/>
            <img src="../assets/images/img-head.png" v-else/> 
          </div>
          <p>{{username}}</p>
        </div>
        <div class="logout">
          <div class="pic">
            <img src="../assets/images/repwd.png" />
          </div>
          <p @click="onClickChangePassword">修改密码 &nbsp;&nbsp;&nbsp;</p>
          <div class="pic">
            <img src="../assets/images/icon-logout.png" />
          </div>
          <p @click="logout">注销登录</p>
        </div>
      </div>
    </div>
    <Menu class="tb-list" @on-select="toMenu" accordion @on-open-change="handleOpen">
      <div v-for="(menu,i) in menuList" :key="i">
        <MenuItem
          v-if="!menu.children"
          :name="menu.name"
          :class="currentPageName == menu.name && 'ivu-menu-item-active'"
        >
          <img :src="menu.icon" />
          {{menu.title}}
        </MenuItem>

        <Submenu v-if="menu.children" :name="menu.name">
          <template slot="title">
            <img :src="menu.icon" />
            {{menu.title}}
          </template>
          <MenuItem
            v-for="(item,j) in menu.children"
            :key="j"
            v-if="!item.category_id"
            :name="item.name"
            :class="currentPageName == item.name && 'ivu-menu-item-active'"
          >{{item.title}}</MenuItem>

          <MenuItem
            v-for="(item,h) in menu.children"
            v-if="item.category_id"
            :name="menu.name + ',' + item.category_id + ',' + item.category_name"
            :key="h"
            :class="currentPageName == (menu.name + ',' + item.category_id) && 'ivu-menu-item-active'"
          >{{item.category_name}}</MenuItem>
        </Submenu>
      </div>
      <div class="bottomQrcode" v-if="!openItem.length &&  type !== '2'">
        <img src="../assets/images/qrcode.png" />
        <span>扫一扫，关注我们</span>
        <p>邮政编码：200032</p>
        <p>联系电话：021-64083368</p>
        <p>传真号码：021-54249331</p>
        <p>联系地址：上海市宛平南路</p>
        <p style="margin-left: 88px;">75号一号楼9楼</p>
      </div>
      <div v-else-if="type !== '2'" @click="showQRModal" style="
        position: fixed;
        bottom: 30px;
        left: 10px;
        z-index: 999;
        width: 60px;
        height: 60px;
        border-radius: 50%;
        background: #fff;
        text-align: center;
        line-height: 60px;
        color: #000;
        cursor: pointer;
      ">二维码</div>
    </Menu>
    <div class="content-box">
      <router-view :key="activeDate"></router-view>
    </div>
    <Modal
      title="修改密码"
      v-model="isShowModal"
      :mask-closable="false"
      class-name="vertical-center-modal"
      class="modal-change-password"
      :footer-hide="true"
      width="660"
    >
      <div class="modify-pwd">
        <ul>
          <li>
            <Input placeholder="请输入手机号" :maxlength="11" v-model="changePasswordInfo.phoneNo" />
            <Button
              @click="sendVerifyCode"
              :style="isCountDownIng && 'color: #ccc;border-color:#ccc'"
            >{{this.isCountDownIng ? this.countDown + 's' : '获取验证码'}}</Button>
          </li>
          <li>
            <Input placeholder="请输入验证码" :maxlength="6" v-model="changePasswordInfo.phoneCode" />
          </li>
          <li>
            <Input
              placeholder="请输入新密码"
              :type="isShowPassword ? 'text' : 'password'"
              :maxlength="16"
              v-model="changePasswordInfo.password"
            />
            <i-switch @on-change="passwordSwitch">
              <span slot="close">
                <label></label>
                <label></label>
                <label></label>
              </span>
            </i-switch>
          </li>
          <li>
            <Input
              placeholder="请再次输入新密码"
              :type="isShowPasswordAgain ? 'text' : 'password'"
              :maxlength="16"
              v-model="changePasswordInfo.passwordAgain"
            />
            <i-switch @on-change="passwordAgainSwitch">
              <span slot="close">
                <label></label>
                <label></label>
                <label></label>
              </span>
            </i-switch>
          </li>
        </ul>
        <Button
          type="primary"
          class="btn"
          @click="changePassword"
          :loading="changePasswordLoading"
        >确认修改</Button>
      </div>
    </Modal>
  </div>
</template>
<script>
import Constant from '../constant/index';
import PageName from "../constant/PageName";
import {toast} from '../libs/LoadingUtil';
import {isMobile} from '../libs/CheckUtil';
import * as Cache from '../cache/Cache';
import * as ExpertLibraryAPI from "../api/ExpertLibraryAPI";

export default {
  data() {
    return {
      activeDate:'',
      openItem: [],
      baseUrl: Constant.ImageUrl,
      existPeopleImage: false,//是否存在上传的用户头像
      peopleImage: '',
      visible: false,
      username: "",
      messageList: [],
      isShowModal:false,
      categoryTypeList: [],
      currentPage:1,
      pageSize:10,
      status:'',

      countDown: 60,// 倒计时秒数
      isCountDownIng: false,// 是否正在倒计时
      changePasswordLoading: false,//修改密码按钮加载
      isShowPassword:false,//是否显示密码
      isShowPasswordAgain:false,//是否显示确认密码
      isApply: false,//是否申请过
      changePasswordInfo:{
        phoneNo:'',//手机号码
        password:'',//密码
        passwordAgain:'',//确认密码
        phoneCode:'',//验证码
      },
      type: Cache.getUserInfo().type
      // menuList:[]
    };
  },
  created(){},
  computed: {
    menuList() {
      let menuList = [];
      if (this.$store.state.app.menuList.length > 0) {
        menuList = this.$store.state.app.menuList[0].children;
        menuList.map(menu => {
          if (menu.name == PageName.PAGE_EXPERT_APPLICATION) {
            //专家申请
             menu.children.map(v=>{
              var  menuItem = v.category_id
              if(menuItem){

                for(var i=0;i< this.categoryTypeList.length;i++){
                 let item = this.categoryTypeList[i]
                 console.log(item.category_id,menuItem)
                  if(item.category_id==menuItem){
                     this.categoryTypeList.splice(i,1);
                  }
                }
              }
             })
            Array.prototype.push.apply(menu.children, this.categoryTypeList);
            // menu.children = this.categoryTypeList;
            // for(var i in this.categoryTypeList){
            //   menu.children.push(this.categoryTypeList[i]);
            //   }

          }
        });
      }
      
      return menuList;
    },
    currentPageName() {
      return this.$store.state.app.currentPageName;
    }
  },
  mounted() {
    this.$store.commit("updateMenulist");
    let userInfo = Cache.getUserInfo();
    this.username = userInfo.username;
    this.asyncSelUserMessage();
    this.asyncGetExpertCategory();
    this.asyncSelectExpertimDto();
    this.asyncIsApply();
  },
  methods: {
    showQRModal() {
      this.$Modal.info({
        content: `<div class="bottomQrcode">
        <img src="${require('../assets/images/qrcode.png')}" style="margin-left:60px;" />
        <span style="margin-left:-135px;">扫一扫，关注我们</span>
        <p>邮政编码：200032</p >
        <p>联系电话：021-64083368</p >
        <p>传真号码：021-54249331</p >
        <p>联系地址：上海市宛平南路75号一号楼9楼</p >
      </div>`
      })
    },
    handleOpen(openItem) {
      if (openItem.find(item => item === 'expert_application')) {
        if (!this.isApply) {
          this.asyncIsApply((isApply) => {
            if (!isApply) {
              this.applyProcess()
            }
          })
        }
      }
      this.openItem = openItem
    },

    //获取用户上传的头像
    asyncSelectExpertimDto() {
      let userInfo = Cache.getUserInfo();
      let params = {
        userid:userInfo.userid,
      }
      ExpertLibraryAPI.selectExpertimDto(params, (resp)=>{
        if (resp.data.peopleimg) {
        this.existPeopleImage = true
        }
        this.peopleImage = resp.data.peopleimg;
      })  
    },
    //是否申请过
    asyncIsApply (cb) {
      let userInfo = Cache.getUserInfo();
      let params = {
        userid: userInfo.userid
      }
      ExpertLibraryAPI.isApply(params,resp => {
        this.isApply = resp.resultMsg === 'true' ? true : false
        if (cb) {
          cb(this.isApply)
        }
      })
    },
    applyProcess () {
      this.$Modal.info({
        title: '申请专家主要流程',
        width: '600',
        content: '<p>1.点击【我的信息】,填写表格并上传附件,点击【提交】;</p>'+
        '<p>2.点击【专家申请】,点击相关类别填写申请信息,点击【提交】;</p>'+
        '<p>3.点击【专家申请】下【我的申请】,点击【下载申请资料】,签字盖章并提交到协会;</p>'+
        '<p>4.等待审核信息。</p>'
      })
    },
    onClickChangePassword(){
      this.isShowModal = true;
    },
    logout() {
      Cache.setUserInfo("");
      this.$router.push({
        name: PageName.PAGE_LOGIN,
        
      });
    },

    clickItem(){
      this.activeDate = (new Date()).toString()
    },

    toMenu(pageName) {
      if (pageName.indexOf(PageName.PAGE_EXPERT_APPLICATION) != -1) {
        //专家申请
        let strs = pageName.split(",");
        this.$router.push({
          name: strs[0],
          query: {
            categoryId: strs[1],
            categoryName: encodeURIComponent(strs[2])
          }
        });
        this.clickItem()
      } else {
        this.$router.push({
          name: pageName
        });
        this.clickItem()
      }
    },
    readMessage(messageId,status) {
      let position = -1;
      this.messageList.map((message, index) => {
        if (message.id == messageId) {
          position = index;
        }
      });
      if (position != -1) {
        this.messageList.splice(position, 1);
      }
      let params={
        rel_id:messageId,
        status:status
      }
      ExpertLibraryAPI.updateMsgStatus(params,resp=>{
        this.asyncSelUserMessage()
      });
    },
    //查询用户消息列表
    asyncSelUserMessage() {
       let userInfo = Cache.getUserInfo();
       this.status=0;
       this.pageSize=100;
      let params={
        currentPage:this.currentPage,
        pageSize:this.pageSize,
        userid:userInfo.userid,
        status:this.status
      }
      ExpertLibraryAPI.queryMessageForExpert(params,resp => {
        this.messageList = resp.data.list ? resp.data.list : [];
      });
    },
    //获取专家类别
    asyncGetExpertCategory() {
      let params = {
        status: "true",
        category_id: ""
      };
      ExpertLibraryAPI.getExpertCategory(params, resp => {
          this.categoryTypeList = resp.data ? resp.data : [];
        
      });
    },
    passwordSwitch(flag){
      this.isShowPassword = flag;
    },
    passwordAgainSwitch(flag){
      this.isShowPasswordAgain = flag;
    },
    // onClickChangePassword(){
    //   this.isShowModal = true;
    // },
    onClickMyCertificate(){
      this.isShowCertificateModal = true;
    },
    /** 验证码倒计时 */
    startCountDown(){
      this.timer = setInterval(() => {
        this.countDown = this.countDown - 1;
        this.isCountDownIng = true;
        if (this.countDown === 0) {
          this.timer && clearInterval(this.timer);
          this.countDown = 60;
          this.isCountDownIng = false;
        }
      }, 1000);
    },
    /** 重置倒计时 */
    resetCountDown(){
      this.timer && clearInterval(this.timer);
      this.countDown = 60;
      this.isCountDownIng = false;
    },
    //验证是否为本人手机号
    selfMobile(phone){
      let userinfo = Cache.getUserInfo();
      if(phone!=userinfo.username){
        return true;
      }else{
        return false;
      }
    },
    //发送验证码
    sendVerifyCode(){
      if (!this.isCountDownIng) {
        if (!this.changePasswordInfo.phoneNo) {
          toast('请输入手机号码');
          return;
        }
        if (this.selfMobile(this.changePasswordInfo.phoneNo)) {
          toast('请使用注册手机号进行验证');
          return;
        }
        this.asyncGetPhonecode();
      }
    },
    changePassword(){
      if (!this.changePasswordInfo.phoneNo) {
        toast('请输入手机号码');
        return;
      }
      if (!isMobile(this.changePasswordInfo.phoneNo)) {
        toast('手机号码格式不正确');
        return;
      }
      if(!this.changePasswordInfo.phoneCode) {
        toast('请输入验证码');
        return;
      }
      if(!this.changePasswordInfo.password) {
        toast('请输入密码');
        return;
      }
      if(!this.changePasswordInfo.passwordAgain) {
        toast('请输入确认密码');
        return;
      }
      if(this.changePasswordInfo.password != this.changePasswordInfo.passwordAgain) {
        toast('两次输入的密码不一致');
        return;
      }
      this.asyncUpdatePwd();
    },
    //修改密码发送验证码
    asyncGetPhonecode(){
      let params = {
        phone_no:this.changePasswordInfo.phoneNo,
      }
      this.startCountDown();
      ExpertLibraryAPI.getPhonecode(params, (resp)=>{
        toast('验证码发送成功');
      }, (failResp)=>{
        this.resetCountDown();
      });
    },
    //修改密码
    asyncUpdatePwd(){
      let params = {
        phoneno:this.changePasswordInfo.phoneNo,//手机号码
        pwd:this.changePasswordInfo.password,//新密码
        phoneCode:this.changePasswordInfo.phoneCode,//手机验证码
      }
      this.changePasswordLoading = true;
      ExpertLibraryAPI.updatePwd(params, (resp)=>{
        this.changePasswordLoading = false;
        toast('修改密码成功，请重新登录');
        Cache.setUserInfo('');
        this.$router.push({
          name: PageName.PAGE_LOGIN
        });
      }, (failResp)=>{
        this.changePasswordLoading = false;
      });
    },
  },
  
};
</script>



// WEBPACK FOOTER //
// src/pages/Main.vue